import React from 'react'

import Base from '../_Base'

const ChevronRight = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path fillRule="evenodd" d="M8.6 7.4 10 6l6 6-6 6-1.4-1.4 4.6-4.6z" />
  </Base>
)

export default ChevronRight
